import { Controller } from "@hotwired/stimulus"

// One button, one menu. This was a split button whose halves measured 0px
// apart and still read as two objects — and a split button is ambiguous
// anyway: which half am I clicking.
export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this._away = (e) => { if (!this.element.contains(e.target)) this.close() }
    this._esc  = (e) => { if (e.key === "Escape") this.close() }
  }

  disconnect() { this.close() }

  toggle(event) {
    event.preventDefault()
    this.menuTarget.hidden ? this.open() : this.close()
  }

  open() {
    this.menuTarget.hidden = false
    this.element.querySelector("[aria-expanded]")?.setAttribute("aria-expanded", "true")
    document.addEventListener("click", this._away)
    document.addEventListener("keydown", this._esc)
  }

  close() {
    this.menuTarget.hidden = true
    const trigger = this.element.querySelector("[aria-expanded]")
    trigger?.setAttribute("aria-expanded", "false")
    document.removeEventListener("click", this._away)
    document.removeEventListener("keydown", this._esc)
    // Only reclaim focus if it is still inside the menu we are closing —
    // unconditional focus() would steal it on disconnect (Turbo swaps) and
    // whenever the user deliberately clicked somewhere else.
    if (this.element.contains(document.activeElement)) trigger?.focus()
  }

  pick() { this.close() }
}
